module.exports = __webpack_public_path__ + "static/media/eu.824e473c.svg";